import React, { useContext, useEffect } from 'react';
import { Route, ScrollToTop, Routes } from '@thd-olt-component-react/router';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { AppContext } from '@thd-nucleus/app-render';
import { Error } from './pages/Error';
import { getRoutes } from './routes.js';
import { getReCaptchaKey, isRecaptchaEnterprise } from './utils/general';
import { CustomerRole, CustomerType } from './models/common/customer';

interface AppProps {
  customerType: CustomerType;
  customerRole: CustomerRole | '';
  svocId: string;
  userId: string;
  serverPages: unknown;
}

const AppRoutes = ({
  customerType,
  customerRole,
  userId,
  svocId,
  serverPages,
}: AppProps) => {
  const { instance } = useContext(AppContext);
  const { currentRouteName, currentRouteComponent } = instance.router;

  const routes = getRoutes(
    currentRouteName,
    currentRouteComponent,
    serverPages,
  );
  const isB2B = customerType.toUpperCase() === 'B2B';

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route
          exact
          path={routes.closeAccount.path}
          element={
            <routes.closeAccount.component
              customerType={customerType}
              customerRole={customerRole}
            />
          }
        />
        <Route
          exact
          path={routes.home.path}
          element={
            <GoogleReCaptchaProvider
              useEnterprise={isRecaptchaEnterprise()}
              reCaptchaKey={getReCaptchaKey()}
            >
              <routes.home.component
                customerType={customerType}
                customerRole={customerRole}
                isB2B={isB2B}
                userId={userId}
                svocId={svocId}
              />
            </GoogleReCaptchaProvider>
          }
        />
        <Route
          exact
          path={routes.addManageUsers.path}
          element={
            <routes.addManageUsers.component
              customerType={customerType}
              customerRole={customerRole}
              isB2B={isB2B}
              userId={userId}
              svocId={svocId}
            />
          }
        />
        <Route
          exact
          path={routes.navigation.path}
          element={
            <routes.navigation.component
              customerType={customerType}
              customerRole={customerRole}
            />
          }
        />
        <Route
          exact
          path={routes.dashboard.path}
          element={
            <routes.dashboard.component
              customerType={customerType}
              customerRole={customerRole}
              isB2B={isB2B}
              userId={userId}
              svocId={svocId}
            />
          }
        />
        <Route path="/error" element={<Error />} />
        <Route element={<Error />} />
      </Routes>
    </>
  );
};

export const App = ({
  customerType,
  customerRole,
  userId,
  svocId,
  serverPages,
}: AppProps) => {
  useEffect(() => {
    document.title = 'The Home Depot';
  }, []);
  return (
    <AppRoutes
      customerRole={customerRole}
      customerType={customerType}
      userId={userId}
      svocId={svocId}
      serverPages={serverPages}
    />
  );
};
